module.exports = __webpack_public_path__ + "img/wurzelraum.a9006ac1.svg";